import {regNavn} from "felles/tjenester/tredjepartsTjenestenavn";
import {IFormController, IRootScopeService} from "angular";
import {Kontekst} from "felles/tjenester/Kontekst";
import {l} from "types/typescriptdefinisjoner_lederplan";
import {BrukerRessurs} from "felles/tjenester/ressurser/BrukerRessurs";
import {WebNavigasjon} from "web/tjenester/WebNavigasjon";
import {InnlastingsindikatorKontroller} from "web/moduler/basis/direktiver/innlastingsindikator";

export class InvitasjonGodtattKontroller {

    static regNavn = "web.InvitasjonGodtattKontroller";

    bruker: l.BrukerModell;
    brukerSkjema: l.OppdaterBrukerSpesifikasjon;

    static forInjisering() {
        return [
            WebNavigasjon.regNavn,
            regNavn.ng.$rootScope,
            Kontekst.regNavn,
            BrukerRessurs.regNavn,
            InvitasjonGodtattKontroller
        ]
    }

    constructor(private navigasjon: WebNavigasjon,
                private $rootScope: IRootScopeService,
                private kontekst: Kontekst,
                private brukerRes: BrukerRessurs) {
        this.bruker = kontekst.autentisertBruker();
        this.brukerSkjema = {
            id: this.bruker.id,
            navn: this.bruker.navn,
            avatarBase64: null
        };
    }

    lagrer = false;

    oppdateBrukerdata(skjema: IFormController) {
        this.lagrer = true;
        this.$rootScope.$emit(InnlastingsindikatorKontroller.vis_innlasting);
        this.brukerRes.oppdater(this.brukerSkjema).$promise
            .then(bruker => {
                this.kontekst.oppdaterAutentisertBruker(bruker);
                this.navigasjon.gåTilForespurtEllerStartsiden();
            })
            .finally(() => {
                this.lagrer = false;
                this.$rootScope.$emit(InnlastingsindikatorKontroller.innlasting_ferdig);
                skjema.$setPristine()
            });
    }
}
